<template>
    <div>
        <v-card outlined>
            <v-card-text>               
                <h3>Generator setting: </h3>
                <v-layout row wrap>
                    <v-flex xs4>
                        Add requested file contained more than <b>{{requestedChars}}</b> chars:
                        <v-slider
                            v-model="requestedChars"
                            
                            max="1000"
                            min="1"                    
                        >
                        </v-slider>
                    </v-flex>
                    <v-flex xs4>
                        Chapters on page ( <b>{{pagination}}</b> ):
                        <v-slider
                            v-model="pagination"
                            
                            max="40"
                            min="1"                    
                        >
                        </v-slider>
                    </v-flex>
                </v-layout>
                <v-btn @click="startGenerator()">Generate</v-btn>
            </v-card-text>                
        </v-card>
        <v-card v-if="content && !keygenerator">
            <v-card-title>
                <div v-for="i in pages" :key="i">
                    <v-btn @click="clickPage(i)">{{(i-1)*pagination+1}} - {{Math.min(i*pagination,content.chapters.length)}}</v-btn>
                </div>
                <v-btn @click="keygenerator = true">Key generator</v-btn>
            </v-card-title>
            <v-card-text>
                <h1>{{content.course_name}}</h1>
                <div v-for="(index, i) in myRange" :key="i">
                   <!--  <div v-html="getIconImage(content.chapters[index].chapter_icon2)">
                    </div> -->
                    <h1 :style="getCourseColor()">{{index+1}} {{content.chapters[index].name}}</h1>
                        <div v-for="(lesson,index2) in content.chapters[index].lessons" :key="index2">
                            <h2 :style="getCourseColor()">{{index+1}}.{{index2+1}} {{lesson.name}}</h2>
                            <p></p>
                            <div v-for="(task,index3) in lesson.tasks" :key="index3">
                                <h3 :style="getCourseColor()"> {{getHeader (index,index2,index3)}}</h3>
                                <div v-html="getContent(index,index2,index3)">
                                </div>
                            </div>
                        </div>
                </div>
            </v-card-text>
        </v-card>

        <v-card v-if="preparing">
            <v-card-title>Preparing...</v-card-title>
        </v-card>
           <v-card v-if="keygenerator">
            <v-card-title>
                <v-btn @click="keygenerator = false">Back to book</v-btn><br/>
            </v-card-title>
            <v-card-title>Keys</v-card-title>
            <v-card-text>
                <div v-for="(chapter,index) in content.chapters" :key="index">
                    <h1>{{index+1}} {{chapter.name}}</h1>
                    <p></p>
                    <div v-for="(lesson,index2) in chapter.lessons" :key="index2">
                        <h2>{{index+1}}.{{index2+1}} {{lesson.name}}</h2>
                        <p></p>
                        <div v-for="(task,index3) in lesson.tasks" :key="index3">                            
                            <div v-html="keyContent(index,index2,index3)">

                            </div>
                        </div>
                    </div>
                </div>
            </v-card-text>        
        </v-card> 
    </div>
</template>

<script>
import axios from '../../axios-auth.js'
import {prepareJupyterTextContent}   from "../../assets/misc.js";

export default {
    data() {
        return {
            content : null,
            keys: '',
            pages: 0,
            pagination: 20,
            requestedChars: 200,
            myRange: [],
            keygenerator : false,
            // addRequestedFile : false,
            preparing : false
        }
    },
    mounted() {
        this.initData()
    },
    methods: {
        initData() {

        },
        unSpan(result, str) {
            var start = 0, end = 0
            while (result.indexOf(str)> -1) {
                start = result.indexOf(str)
                end = result.indexOf('</span>',start)
                result = result.substring(0, end) + result.substring(end+7)
                result = result.substring(0,start) + result.substring(start + str.length)
            }
            return result
        },
        clearSyntax(result) {
            var str = ' class="ql-syntax" spellcheck="false"'
            while (result.indexOf(str)> -1) {
                result = result.substring(0, result.indexOf(str)) + result.substring(result.indexOf(str) + str.length)
            }
            result = this.unSpan(result, '<span class="hljs-meta">')
            result = this.unSpan(result, '<span class="hljs-attr">')
            result = this.unSpan(result, '<span class="hljs-name">')
            result = this.unSpan(result, '<span class="hljs-tag">')
            result = this.unSpan(result, '<span class="hljs-built_in">')
            result = this.unSpan(result, '<span class="hljs-keyword">')
            result = this.unSpan(result, '<span class="hljs-string">')
            result = this.unSpan(result, '<span class="hljs-function">')
            result = this.unSpan(result, '<span class="hljs-comment">')
            return result
        },
        buildContent(data) {
            this.content = data
            for(let i = 0; i < this.content.chapters.length; i++)  {
                for(let j = 0; j < this.content.chapters[i].lessons.length; j++) {
                    for(let k = 0; k < this.content.chapters[i].lessons[j].tasks.length; k++) {
                        this.content.chapters[i].lessons[j].tasks[k].showContent = this.getContent(i,j,k)                           
                        this.content.chapters[i].lessons[j].tasks[k].showKey = this.keyContent(i,j,k)                           
                    }
                }
            }
        },
        getContent(index,index2,index3){
            let _type = this.content.chapters[index].lessons[index2].tasks[index3].task_type_id
            let task = this.content.chapters[index].lessons[index2].tasks[index3]
            var _data, _answers
            switch (_type) {
                case 1 : return this.content.chapters[index].lessons[index2].tasks[index3].content+"<br/>"
                case 2 : return JSON.parse(task.content).content+"<br/>"
                case 3 : // one correct
                case 4 : // more correct
                         _data = JSON.parse(task.content).content
                         _answers = JSON.parse(task.content).answer_list
                         _data += "<ul>"
                         for(let i = 0; i < _answers.length; i++ ) {
                             _data += "<li>" + this.prepareToHTML(_answers[i].answer) +"</li>"
                          }
                         _data += "</ul><br/>" 
                         return _data
                case 5 : // insert code
                         _data = JSON.parse(task.content).content
                         _data = this.clearSyntax(_data)
                         while (_data.indexOf('§§') > -1) {
                             let zac = _data.indexOf('§§')
                             let kon = _data.indexOf('§§', zac+1)
                             _data = _data.substring(0,zac) + '_____' + _data.substring(kon+2)
                         }
                         // before pre
                         start = 0                         
                         while (_data.indexOf("<pre>", start) > -1) {
                            start = _data.indexOf("<pre>", start) 
                            end = _data.indexOf("</pre>",start)
                            _data = _data.substring(0, start) + "<pre>" + 
                                    this.prepareToHTML(_data.substring(start+5, end)) + "</pre>" +
                                    _data.substring(end+6)
                            start = _data.indexOf("<pre>", end) 
                            if (start == -1) break
                                     
                         } 

                         return (_data) + "<br/>"
                case 6 : // drag
                         var _variants = []
                         _data = JSON.parse(task.content).content
                         _data = this.clearSyntax(_data)

                         while (_data.indexOf('§§') > -1) {
                             let zac = _data.indexOf('§§')
                             let kon = _data.indexOf('§§', zac+1)
                             _variants.push(_data.substring(zac+2,kon))
                             _data = _data.substring(0,zac) + '_____' + _data.substring(kon+2)
                         }
                         var _fakes = JSON.parse(task.content).fakes
                         for(let i = 0; i<_fakes.length; i++) {
                             _variants.push(_fakes[i])
                         }
                         _variants = this.shuffleArray(_variants)
                         // before pre
                         start = 0                         
                         while (_data.indexOf("<pre>", start) > -1) {
                            start = _data.indexOf("<pre>", start) 
                            end = _data.indexOf("</pre>",start)
                            _data = _data.substring(0, start) + "<pre>" + 
                                    this.prepareToHTML(_data.substring(start+5, end)) + "</pre>" +
                                    _data.substring(end+6)    
                            start = _data.indexOf("<pre>", end) 
                            if (start == -1) break   
                         } 

                         _data = _data + '<ul>'
                         for(let i = 0; i<_variants.length; i++) {
                             _data += '<li>' + this.prepareToHTML(_variants[i]) + '</li>'
                         }
                         _data += '</ul><br/>'
                         return _data
                case 7 : // shuffled code
                        _data = JSON.parse(task.content).content
                        _data = this.clearSyntax(_data)
                        var result = this.clearSyntax(JSON.parse(task.content).code)
                        var answers = []
                        var start = 0
                        var end = 0
                        var codes = []
                        while (result.indexOf('<pre>')> -1) {
                            start = result.indexOf('<pre>')
                            end = result.indexOf('</pre>')
                            codes.push(result.substring(start + 5, end))
                            result = result.substring(0,start) + result.substring(end+6)
                        }
                    
                        result.replace(/<p>(.*?)<\/p>/g, function(match, g1) { 
                            answers.push(g1)
                        })
                        for(let i = 0; i<codes.length; i++) {
                            result = codes[i]
                            while (result.indexOf('\n')> -1) {
                                var ind = result.indexOf('\n')
                                answers.push(result.substring(0, ind))
                                result = result.substring(ind+1)
                            }
                            if (result.length>0) answers.push(result)
                        }
                        answers = this.shuffleArray(answers)
                        _data += "<ul>"
                        for(let i = 0; i < answers.length; i++) {
                            _data += "<li>" + this.prepareToHTML(answers[i]) + "</li>"
                        }
                        _data += "</ul><br />"
                        return _data
                case 8 : // code
                case 9 : // code
                      //  _data = "<b>" + JSON.parse(task.content).title + "</b>"
                        _data = JSON.parse(task.content).assignment
                        // list of requested files
                        var _filenames = JSON.parse(task.globals).files
                        var _files = JSON.parse(task.content).files
                        for(let i = 0; i < _filenames.files.length; i++ ) {
                            if (_files[i].rContent.length > this.requestedChars) {
                                _data += "<br /><b>" + _filenames.files[i] + "</b>"
                                _data += "<pre>" + this.prepareToHTML(_files[i].rContent) + "</pre>"
                            }
                        }
                        return _data + "<br />"                 
                case 11 : // rules
                      //  _data = "<b>" + JSON.parse(task.content).title + "</b>"
                        _data = JSON.parse(task.content).assignment
                        _data += "<pre>" + this.prepareToHTML(JSON.parse(task.content).requestedFile) + "</pre>"
                        return _data + "<br />"                
                case 10 : // sql code
                      //  _data = "<b>" + JSON.parse(task.content).title + "</b>"
                        _data = JSON.parse(task.content).assignment
                        return _data + "<br />"  
                case 12: _data = JSON.parse(task.content)
                         _data = this.processExtendedContent(_data, true) // send list
                //         console.log(task.content)
                         return _data
                case 13: _data = JSON.parse(task.content).content
                         _data = this.processExtendedContent(_data, true) // send list
                //         console.log(task.content)
                         return _data
                case 14: 
                case 15: _data = this.processExtendedContent(JSON.parse(task.content).content, true)
                         _answers = JSON.parse(task.content).answer_list       
                         _data = _data + '<ul>'
                         for(let i = 0; i < _answers.length; i++ ) {
                             const _style = i%2==0 ? 'background-color:#e0e0e0':'background-color:#eeeeee'
                             _data += '<li><div style="'+_style +'">' + this.processExtendedContent(_answers[i].cells, false) +"</div></li>"
                          }
                         _data = _data + '</ul>'
                //         console.log(task.content)
                         return _data  
                case 16: // return JSON.parse(task.content)
                         _data = JSON.parse(task.content)
                         _data = this.processExtendedContent(_data, true) // send list
                         return _data 
                default: return '--- ERROR ---'
            }

        },
        prepareToHTML(data) {
            var poz = 0
            while (data.indexOf("<",poz) > -1) {
               poz = data.indexOf("<",poz)
               data = data.substring(0,poz+1) + '|' + data.substring(poz+1)
               poz++
               /* eslint-disable no-console */
               // console.log(data)
            }
            return data;
        },

/*             let _type = this.content.chapters[index].lessons[index2].tasks[index3].task_type_id
            let task = this.content.chapters[index].lessons[index2].tasks[index3]
            var _data, _answers
            switch (_type) {
                case 1 : return this.content.chapters[index].lessons[index2].tasks[index3].content+"<br/>"
                case 2 : return JSON.parse(task.content).content+"<br/>"
                case 3 : // one correct
                case 4 : // more correct
                         _data = JSON.parse(task.content).content
                         _answers = JSON.parse(task.content).answer_list
                         _data += "<ul>"
                         for(let i = 0; i < _answers.length; i++ ) {
                             _data += "<li>" + _answers[i].answer +"</li>"
                          }
                         _data += "</ul><br/>" 
                         return _data
                case 5 : // insert code
                         _data = JSON.parse(task.content).content
                         while (_data.indexOf('§§') > -1) {
                             let zac = _data.indexOf('§§')
                             let kon = _data.indexOf('§§', zac+1)
                             _data = _data.substring(0,zac) + '_____' + _data.substring(kon+2)
                         }
                         return _data + "<br/>"
                case 6 : // drag
                         var _variants = []
                         _data = JSON.parse(task.content).content
                         while (_data.indexOf('§§') > -1) {
                             let zac = _data.indexOf('§§')
                             let kon = _data.indexOf('§§', zac+1)
                             _variants.push(_data.substring(zac+2,kon))
                             _data = _data.substring(0,zac) + '_____' + _data.substring(kon+2)
                         }
                         var _fakes = JSON.parse(task.content).fakes
                         for(let i = 0; i<_fakes.length; i++) {
                             _variants.push(_fakes[i])
                         }
                         _variants = this.shuffleArray(_variants)
                         _data += '<ul>'
                         for(let i = 0; i<_variants.length; i++) {
                             _data += '<li>' + _variants[i] + '</li>'
                         }
                         _data += '</ul><br/>'
                         return _data
                case 7 : // shuffled code
                        _data = JSON.parse(task.content).content
                        var result = JSON.parse(task.content).code
                        var answers = []
                        var str = ' class="ql-syntax" spellcheck="false"'
                        while (result.indexOf(str)> -1) {
                            result = result.substring(0, result.indexOf(str)) + result.substring(result.indexOf(str) + str.length)
                        }
                        var start = 0
                        var end = 0
                        var codes = []
                        while (result.indexOf('<pre>')> -1) {
                            start = result.indexOf('<pre>')
                            end = result.indexOf('</pre>')
                            codes.push(result.substring(start + 5, end))
                            result = result.substring(0,start) + result.substring(end+6)
                        }
                    
                        result.replace(/<p>(.*?)<\/p>/g, function(match, g1) { 
                            answers.push(g1)
                        })
                        for(let i = 0; i<codes.length; i++) {
                            result = codes[i]
                            while (result.indexOf('\n')> -1) {
                                var ind = result.indexOf('\n')
                                answers.push(result.substring(0, ind))
                                result = result.substring(ind+1)
                            }
                            if (result.length>0) answers.push(result)
                        }
                        answers = this.shuffleArray(answers)
                        _data += "<ul>"
                        for(let i = 0; i < answers.length; i++) {
                            _data += "<li>" + answers[i] + "</li>"
                        }
                        _data += "</ul><br />"
                        return _data
                case 8 : // code
                case 9 : // code
                        _data = "<b>" + JSON.parse(task.content).title + "</b>"
                        _data += JSON.parse(task.content).assignment
                        // list of requested files
                        var _filenames = JSON.parse(task.globals).files
                        var _files = JSON.parse(task.content).files
                        for(let i = 0; i < _filenames.files.length; i++ ) {
                            _data += "<br /><b>" + _filenames.files[i] + "</b>"
                            _data += "<pre>" + _files[i].rContent + "</pre>"
                        }
                        return _data + "<br />"                 
                case 11 : // rules
                        _data = "<b>" + JSON.parse(task.content).title + "</b>"
                        _data += JSON.parse(task.content).assignment
                        _data += "<pre>" + JSON.parse(task.content).requestedFile + "</pre>"
                        return _data + "<br />"                
                case 10 : // sql code
                        _data = "<b>" + JSON.parse(task.content).title + "</b>"
                        _data += JSON.parse(task.content).assignment
                        return _data + "<br />"                  
                default: return " ------ "
            }

        },*/
         keyContent(index,index2,index3){
            let _type = this.content.chapters[index].lessons[index2].tasks[index3].task_type_id
            let task = this.content.chapters[index].lessons[index2].tasks[index3]
            var _keys, _points, _answers, _data
            switch (_type) {
                case 1 : return ''
                case 2 : _keys = (index+1)+"."+(index2+1)+"."+(index3+1)+"."
                         _answers = JSON.parse(task.content).answer_list
                         _points = JSON.parse(task.globals)
                         _keys += "<ul>"
                         for(let i = 0; i < _answers.length; i++ ) {
                             _keys += "<li>" + this.prepareToHTML(_answers[i].answer) + " [" + _points.ratings[i] + "%]"+"</li>"
                          }
                         _keys += "</ul><br>" 
                         return _keys
                case 3 :
                case 4 : _keys = (index+1)+"."+(index2+1)+"."+(index3+1)+"."
                         _answers = JSON.parse(task.content).answer_list
                         _points = JSON.parse(task.globals)
                         _keys += "<ul>"
                         for(let i = 0; i < _answers.length; i++ ) {
                             if (_points.ratings[i] > 0) 
                                _keys += "<li>" + this.prepareToHTML(_answers[i].answer) + "</li>"
                          }
                         _keys += "</ul><br>" 
                         return _keys      
                case 5 : // insert code
                case 6 : // insert code
                         _keys = (index+1)+"."+(index2+1)+"."+(index3+1)+"."
                         _data = JSON.parse(task.content).content
                         _keys += "<ul>"
                         while (_data.indexOf('§§') > -1) {
                             let zac = _data.indexOf('§§')
                             let kon = _data.indexOf('§§', zac+1)
                             _keys += '<li>' + this.prepareToHTML(_data.substring(zac+2, kon)) + '</li>'
                             _data = _data.substring(kon+1) 
                         }
                         _keys += "</ul><br>"
                         return _keys                   
                case 7 : // lines
                        _data = (index+1)+"."+(index2+1)+"."+(index3+1)+"."
                        var result = JSON.parse(task.content).code
                        var answers = []
                        var str = ' class="ql-syntax" spellcheck="false"'
                        while (result.indexOf(str)> -1) {
                            result = result.substring(0, result.indexOf(str)) + result.substring(result.indexOf(str) + str.length)
                        }
                        var start = 0
                        var end = 0
                        var codes = []
                        while (result.indexOf('<pre>')> -1) {
                            start = result.indexOf('<pre>')
                            end = result.indexOf('</pre>')
                            codes.push(result.substring(start + 5, end))
                            result = result.substring(0,start) + result.substring(end+6)
                        }
                    
                        result.replace(/<p>(.*?)<\/p>/g, function(match, g1) { 
                            answers.push(g1)
                        })
                        for(let i = 0; i<codes.length; i++) {
                            result = codes[i]
                            while (result.indexOf('\n')> -1) {
                                var ind = result.indexOf('\n')
                                answers.push(result.substring(0, ind))
                                result = result.substring(ind+1)
                            }
                            if (result.length>0) answers.push(result)
                        }
                        _data += "<ul>"
                        for(let i = 0; i < answers.length; i++) {
                            _data += "<li>" + this.prepareToHTML(answers[i]) + "</li>"
                        }
                        _data += "</ul><br />"
                        return _data           
                case 8 : // code
                case 9 : // code
                        _data = "<b>" + (index+1)+"."+(index2+1)+"."+(index3+1)+"." + "</b>"
                        // list of requested files
                        var _filenames = JSON.parse(task.globals).files
                        var _files = JSON.parse(task.content).files
                        for(let i = 0; i < _filenames.files.length; i++ ) {
                            _data += "<br /><b>" + _filenames.files[i] + "</b>"
                            _data += "<pre>" + this.prepareToHTML(_files[i].aContent) + "</pre>"
                        }
                        return _data + "<br />"                 
                case 10 : // sql code
                        _data = "<b>" + (index+1)+"."+(index2+1)+"."+(index3+1)+"." + "</b>"
                        _data += "<pre>" + this.prepareToHTML(JSON.parse(task.content).files[0].aContent) + "</pre>"
                        return _data + "<br />"                  
                case 11 : // sql code
                        _data = "<b>" + (index+1)+"."+(index2+1)+"."+(index3+1)+"." + "</b>"
                        _data += "<pre>" + this.prepareToHTML(JSON.parse(task.content).authorsFile) + "</pre>"
                        return _data + "<br />"                  
     
                    default: return " ------ "
            }
        }, 
        shuffleArray(array) {
            for (var i = array.length - 1; i > 0; i--) {
                var j = Math.floor(Math.random() * (i + 1));
                var temp = array[i];
                array[i] = array[j];
                array[j] = temp;
            }
            return array
        },
        clickPage(i) {
           this.createRange((i-1)*this.pagination,i*this.pagination-1) 
        },
        createRange(start,end) {
            //console.log(start +" - " + end)
            this.myRange = []
            for(let i = start; i<= Math.min(end,this.content.chapters.length-1); i++) {
                this.myRange.push(i)
            }
            // console.log(this.myRange)
        },
        getCourseColor() {
            return "color: " +this.content.course_color + ";"
        },
        getHeader(index,index2,index3) {
            // text
            if (this.content.chapters[index].lessons[index2].tasks[index3].task_type_id == 1)
              return "🕮 " + (index+1) + "." + (index2+1) + "." + (index3+1)
            // program
            if (this.content.chapters[index].lessons[index2].tasks[index3].task_type_id >= 8 && this.content.chapters[index].lessons[index2].tasks[index3].task_type_id <= 11) {
                let task = this.content.chapters[index].lessons[index2].tasks[index3]
                return "⌨ " + (index+1) + "." + (index2+1) + "." + (index3+1) + " " + JSON.parse(task.content).title
            }              
            // task
            return "📝 " + (index+1) + "." + (index2+1) + "." + (index3+1)
        },
        startGenerator() {
            this.content = null
            this.preparing = true
            axios.get('/get-book/' + this.$route.params.id, this.$store.getters.getAxiosConfig)
                .then(res => {
                    let ch = res.data.chapters.length  
                    // console.log('chaprers:' + ch)  
                    if (ch % this.pagination == 0) this.pages = ch / this.pagination
                     else this.pages = Math.round(ch / this.pagination + 0.5)
                    this.content = res.data
                    this.processQuestions()
                    // console.log(this.content)
                    this.clickPage(1) 
                    // this.buildContent(res.data)
                    this.preparing = false
                })
                .catch(error => {
                    this.$store.commit('setFeedback', error)          
                }) 
        },
        getIconImage(myIcon) {
            return '<img src="'+ myIcon + '" width="200" height ="200">'
        },
        processExtendedContent(_list, _br) {
            // console.log(_list)
            let _content = ''
            for(let i = 0; i<_list.length; i++) {
                //console.log(_list[i].cell_type)
                const _ctype = _list[i].cell_type
                if (_ctype=='editor') {
                    for(let j = 0; j < _list[i].source.length; j++) {
                        _content = _content + _list[i].source[j]
                    }  
                }                                    
                if (_ctype=='code') {
                    //console.log(_list[i])
                    if (_br) _content += '<br />'
                    _content = _content + '<pre>'
                    for(let j = 0; j < _list[i].source.length; j++) {
                        _content = _content + _list[i].source[j]
                    }  
                    _content = _content + '</pre>'
                    if (_list[i].outputs.length > 0) {
                        _content = _content + "<br /><B>Program output:</B><pre>"
                        for(let j = 0; j < _list[i].outputs.length; j++) { 
                            if (_list[i].outputs[j].atype=='text')
                                _content = _content + _list[i].outputs[j].output
                            if (_list[i].outputs[j].atype=='png') {
                                _content = _content + '<img src="data:image/png;base64,'+_list[i].outputs[j].output+'">'
                            }
                        }
                        _content = _content + '</pre>' 
                        if (_br) _content += '<br />'
                    }

                }
                if (_ctype=='markdown') {
                    _content = _content + prepareJupyterTextContent(_list[i].source)
                }
                if (_ctype=='raw') {
                    for(let j = 0; j < _list[i].source.length; j++) {
                        _content = _content + _list[i].source[j]
                    }  
                }
                if (_ctype!='editor' && _ctype!='code' && _ctype!='markdown' && _ctype!='raw') {
                    _content = _content + '--- ERROR ---'
                }
            }
            return _content
        },
        processQuestions() {
            console.log("data")
            console.log(this.content)
            for(let i=0; i<this.content.chapters.length; i++) {
                for(let j=0; j<this.content.chapters[i].lessons.length; j++) {
                    for(let k=0; k<this.content.chapters[i].lessons[j].tasks.length; k++) {
                        console.log("" + (i+1) + "." + (j+1) + "." + (k+1) + ";" + 
                                    this.content.chapters[i].lessons[j].tasks[k].id + ";"+
                                    this.content.chapters[i].lessons[j].tasks[k].task_type_id + ";" +
                                    this.pocetVsetkychZnakov(this.content.chapters[i].lessons[j].tasks[k].content, this.content.chapters[i].lessons[j].tasks[k].task_type_id) + ";"+
                                    this.pocetPlatnychZnakov(this.content.chapters[i].lessons[j].tasks[k].content, this.content.chapters[i].lessons[j].tasks[k].task_type_id) + ";"+
                                    this.pocetZnakovMoznosti(this.content.chapters[i].lessons[j].tasks[k].content, this.content.chapters[i].lessons[j].tasks[k].task_type_id) + ";"+
                                    this.pocetMoznosti(this.content.chapters[i].lessons[j].tasks[k].content, this.content.chapters[i].lessons[j].tasks[k].task_type_id) + ";"+
                                    this.pocetSpravnych(this.content.chapters[i].lessons[j].tasks[k].globals, this.content.chapters[i].lessons[j].tasks[k].task_type_id) + ";"+
                                    this.pocetObrazkov(this.content.chapters[i].lessons[j].tasks[k].content, this.content.chapters[i].lessons[j].tasks[k].task_type_id) + ";"                                
                                )
                    }

                }
            }
            // console.log(this.content)
        },
        pocetVsetkychZnakov(_content,_ttid) {
            //console.log(_content)
            if (_ttid == 1) {
                return _content.length
            }
            if (_ttid == 2) {
                const _data = JSON.parse(_content)
                return _data.content.length
            }
            if (_ttid == 3 || _ttid == 4) {
                const _data = JSON.parse(_content)
                var _answers_length = 0
                for(let i=0; i<_data.answer_list.length; i++) {
                    _answers_length += _data.answer_list[i].answer.length

                }
                return _data.content.length + _answers_length
            }
            return -1
        },
        pocetPlatnychZnakov(_content,_ttid) {
            if (_ttid == 1) {
                return this.platne(_content).length
            }
            if (_ttid == 2) {
                const _data = JSON.parse(_content)
                return this.platne(_data.content).length
            }
            if (_ttid == 3 || _ttid == 4) {
                const _data = JSON.parse(_content)
                var _answers_length = 0
                for(let i=0; i<_data.answer_list.length; i++) {
                    _answers_length += this.platne(_data.answer_list[i].answer).length
                }
                return this.platne(_data.content).length + _answers_length
            }
            return -1
        },  
        pocetZnakovMoznosti(_content,_ttid) {
            if (_ttid < 3) {
                return 0
            }
            if (_ttid == 3 || _ttid == 4) {
                const _data = JSON.parse(_content)
                var _answers_length = 0
                for(let i=0; i<_data.answer_list.length; i++) {
                    _answers_length += this.platne(_data.answer_list[i].answer).length
                }
                return _answers_length
            }
            return -1        
        },
        pocetMoznosti(_content,_ttid) {
            if (_ttid < 3) {
                return 0
            }
            if (_ttid == 3 || _ttid == 4) {
                const _data = JSON.parse(_content)
                return _data.answer_list.length
            }
            return -1        
        },
        pocetSpravnych(_content,_ttid) {
            if (_ttid < 3) {
                return 0
            }
            if (_ttid == 3 || _ttid == 4) {
                const _data = JSON.parse(_content)
                var _answers_cor = 0
                for(let i=0; i<_data.ratings.length; i++) {
                    _answers_cor += _data.ratings[i] > 0 ? 1:0
                }
                return _answers_cor
            }
            return -1     
        },
        pocetObrazkov(_content,_ttid) {
            var regexPattern = /<img[^>]*>/gi ///<img\b[^>]*>/gi
            if (_ttid == 1) {
                let x = _content.match(regexPattern)
                return x == null? 0 : x.length
            }
            if (_ttid >= 2 && _ttid <= 4) {
                const _data = JSON.parse(_content)
                let x = _data.content.match(regexPattern)
                return x == null? 0 : x.length
            }
            return -1
        },
        platne(_text) {
            const x = _text.replace(/<[^>]+>/g, "")
            return x
        }
    }

}
</script>

<style>
</style>
